// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"77d3c200","453":"c565ad6d"}[chunkId] + ".chunk.js";
};